export const ServicesOfferedEnum = {
  key: 1217,
  value: 'ServicesOffered',
};
